import { Button, Container, Typography } from "@mui/material";
import lineup from "../../images/assets/epflineupnew.png";
// import sponsor from "../../images/assets/sponsorepf.png";

import gifEpf from "../../images/logo/EPF 2024 GIF - LANDSCAPE.gif";

function Home() {
  return (
    <div className="home">
      <div className="home-tickets">
        <Container maxWidth="xl">
          <div className="border-lineup">
            <div className="lineup-container">
              <img src={lineup} className="lineup-image" alt="lineup" />
              {/* 
              <div className="sponsor-image" >

              <Typography className="text">
                Official Festival Partner
              </Typography>

              <img src={sponsor} alt="sponsor" />
              </div > */}
            </div>
              <Typography className="home-title" variant="h4">Tickets On Sale Now</Typography>
              <Typography className="home-title" variant="h4">Sunday 6th September 2026</Typography>
            <div className="info-container">
              <Button
                href="https://edinburghpsychfest.seetickets.com/event/edinburgh-psych-fest-2027/various-venues/3708279"
                color="primary"
                size="large"
                variant="contained"
                sx={{
                  marginTop: "30px",
                  marginBottom: "0",
                  fontSize: "24px",
                  padding: "15px",
                  borderWidth: "3px",
                  borderRadius: "0px",
                }}
                target="_blank"
                className="ticket-header-button"
              >
                Buy Tickets
              </Button>
              <div className="info-container-divs logo-div">
                <img src={gifEpf} className="gif-image" alt="lineup" />
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
}
export default Home;
